import css from '@styled-system/css';
import variant from '@styled-system/variant';
import { ThemeStyles } from '@honda-canada/design-system-react';

import { ACURA_SITE_NAME, HONDA_SITE_NAME, PE_SITE_NAME } from '../../../utils/constants';

const themeStyles = new ThemeStyles();

themeStyles.addBaseStyles('DealerHoursContainer')(
  css({
    display: 'flex',
    alignItems: 'flex-start',
    flexDirection: 'column',
    justifyContent: 'center',
  }),
);

themeStyles.addBaseStyles('DealerHoursRow')(
  css({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-around',
    '@media only screen and (max-width: 1155px)': {
      maxWidth: '240px',
    },
  }),
);

themeStyles.addThemeStyles(
  'DealerHoursRow',
  'acura',
)(
  css({
    '@media only screen and (max-width: 1155px)': {
      maxWidth: '150px',
    },
  }),
);

themeStyles.addBaseStyles('DealerHoursDescription')(
  css({
    mr: 'xxs',
    fontSize: '10px',
    color: 'grey.0',
    lineHeight: '22px',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
  }),
  variant({
    variants: {
      [HONDA_SITE_NAME]: {
        fontFamily: 'default',
        pt: '0px',
      },
      [ACURA_SITE_NAME]: {
        fontFamily: 'headingRegular',
        pt: '2px',
      },
    },
    mr: 'xxs',
  }),
);

themeStyles.addBaseStyles('DealerLabel')(
  css({
    mr: 'xxs',
    textDecoration: 'none',
  }),
  variant({
    variants: {
      [HONDA_SITE_NAME]: {
        fontFamily: 'bold',
        color: 'grey.0',
      },
      [ACURA_SITE_NAME]: {
        fontFamily: 'headingRegular',
        color: 'black',
      },
      [PE_SITE_NAME]: {
        fontFamily: 'bold',
        color: 'black',
      },
    },
    mr: 'xxs',
  }),
);

themeStyles.addBaseStyles('DealerName')(
  css({
    fontSize: 'sm',
    lineHeight: '18px',
    letterSpacing: '0.06px',
    textDecoration: 'none',
    fontWeight: 500,
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
  }),
  variant({
    variants: {
      [HONDA_SITE_NAME]: {
        fontFamily: 'default',
        color: 'grey.0',
      },
      [ACURA_SITE_NAME]: {
        fontFamily: 'headingRegular',
        color: 'black',
      },
      [PE_SITE_NAME]: {
        fontFamily: 'default',
        fontWeight: 400,
        color: 'black',
        lineHeight: '22px',
      },
    },
    mr: 'xxs',
  }),
);

themeStyles.addBaseStyles('StickyMedia')(
  ({ theme, top, hiddenOnScroll, renderBelowModelPageNav, headerUnderModelNav }) => {
    const zIndex = renderBelowModelPageNav
      ? theme.zIndices.subNavigationBar - 1
      : // TODO: add header z-index to theme,
        // DealerStatusAndHours should have minus 1 to stay below Header's pop-up menu
        theme?.zIndices?.header || 1020 - 1;
    return css({
      position: hiddenOnScroll ? 'static' : 'sticky',
      top,
      zIndex: headerUnderModelNav ? 0 : zIndex,
      '@media not screen': {
        display: 'none',
      },
    });
  },
);

export default themeStyles;
